import { render, staticRenderFns } from "./_author.vue?vue&type=template&id=930ad0ac&"
import script from "./_author.vue?vue&type=script&lang=ts&"
export * from "./_author.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports